import React from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';

import * as navTrans from '../translations/navigation/translation';

const Nav = (props) => {
    let lang = props.settings.locale;
    if (props.settings.locale === 'de-AT') {
      lang = 'at';
    }
    return (
      <div className="team_sport_nav">

          <NavLink className="stepItem" activeClassName="active" to={`/colors/${props.settings.groupID}/`}>
            <div className="stepNumber">1</div>
            <div className="stepText">{navTrans[lang].Pick_Color}</div>
          </NavLink>

        <div className="divider" />

        {props.colorCanContinue ?
          <NavLink className="stepItem" to="/amount/">
            <div className="stepNumber">2</div>
            <div className="stepText">{navTrans[lang].Pick_quantity}</div>
          </NavLink>
          :
          <div className="stepItem">
            <div className="stepNumber">2</div>
            <div className="stepText">{navTrans[lang].Pick_quantity}</div>
          </div>
        }

        <div className="divider" />

        {props.sizeCanContinue ?
          <NavLink className="stepItem" to="/print/">
            <div className="stepNumber">3</div>
            <div className="stepText">{navTrans[lang].Print_Options}</div>
          </NavLink>
          :
          <div className="stepItem">
            <div className="stepNumber">3</div>
            <div className="stepText">{navTrans[lang].Print_Options}</div>
          </div>
        }

        <div className="divider" />

        <NavLink className="stepItem" to="/revieworder/">
          <div className="stepNumber">
            <span className="icon-checkmark icon-checkmark-dims" />
          </div>
          <div className="stepText">{navTrans[lang].Review_Order}</div>
        </NavLink>
      </div>
    );
};

const mapState = state => (
  {
    settings: state.settings,
    sizeCanContinue: state.sizeCanContinue,
    colorCanContinue: state.colorCanContinue,
  }
);
export default connect(mapState, null)(Nav);
